import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { validateIsNotempty, validateCharecters, validateEmail } from '../../../utils';

const AddAddressBook = (props) =>
{
	const { open, handleClose, handleSave, data, handleUpdate } = props;
	const [ formData, setFormData ] = useState({ name: '', email: '' });
	const [ errorObj, setError ] = useState({});

	useEffect(() =>
	{
		if (data && data !== null)
		{
			setFormData(data);
		}
	}, [ data ]);

	const handleSubmit = () =>
	{
		const { name, email } = formData;

		const error = {};

		if (!validateIsNotempty(name))
		{
			error['name'] = 'Please Enter Name';
		}
		else if (!validateCharecters(name))
		{
			error['name'] = 'Please Enter valid Name';
		}

		if (!validateIsNotempty(email))
		{
			error['email'] = 'Please Enter email';
		}
		else if (!validateEmail(email))
		{
			error['email'] = 'Please Enter valid email';
		}

		if (Object.keys(error).length <= 0)
		{
			setError({});
			if (data !== null)
			{
				handleUpdate(data._id, formData);
			}
			else
			{
				handleSave(formData);
			}
		}
		else
		{
			setError(error);
		}

	};

	const handleChange = (val, name) =>
	{
		setFormData((prevState) => { return { ...prevState, [name]: val }; });
	};

	return (
		<Dialog open={open}>
			<DialogTitle>Add Contact</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					margin='dense'
					id='name'
					label='Name'
					type='text'
					fullWidth
					variant='standard'
					onChange={(e) => handleChange(e.target.value, 'name')}
					value={formData?.name ? formData.name : ''}
					error={errorObj?.name}
					helperText={errorObj?.name}
				/>
				<TextField
					margin='dense'
					id='email'
					label='Email Address'
					type='email'
					fullWidth
					variant='standard'
					onChange={(e) => handleChange(e.target.value, 'email')}
					value={formData?.email ? formData.email : ''}
					error={errorObj?.email}
					helperText={errorObj?.email}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit}>{data !== null ? 'Update' : 'Save'}</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddAddressBook;